import { useSyncExternalStore } from "react";

import {
  HEADER_MENU_DESKTOP_MEDIA_QUERY,
} from "@/ui/components/navigation/Header/Header.config";

const subscribeToHeaderMenuBreakpoint = (onChange: () => void) => {
  const mediaQuery = window.matchMedia(HEADER_MENU_DESKTOP_MEDIA_QUERY);

  mediaQuery.addEventListener("change", onChange);

  return () => mediaQuery.removeEventListener("change", onChange);
};

const getHeaderMenuBreakpointSnapshot = () =>
  window.matchMedia(HEADER_MENU_DESKTOP_MEDIA_QUERY).matches;

const getHeaderMenuServerBreakpointSnapshot = () => false;

export const useHeaderMenu = () => {
  const isHeaderMenuDesktop = useSyncExternalStore(
    subscribeToHeaderMenuBreakpoint,
    getHeaderMenuBreakpointSnapshot,
    getHeaderMenuServerBreakpointSnapshot,
  );

  return {
    isHeaderMenuDesktop,
  };
};
